module.exports = __webpack_public_path__ + "media/DocumentManagement.69bba98713a11b48de7cfb03641d0153.svg";